import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { contactDetailEditSchema } from '../../../ValidationSchema';
import { editContactDetails, getCity, getCountry, getState } from '../../../../asiosConfig';
import Popup from '../../../Popup';
import { Button, Card, CardContent, CardHeader, MenuItem, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const ContactDetailsEdit = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const userProfileData = location.state?.userProfileData || {};

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

    const handleClosePopup = () => {
        setPopupData({ ...popupData, open: false });
    };

    useEffect(() => {
        if (popupData.open) {
            const timer = setTimeout(() => {
                setPopupData(prev => ({ ...prev, open: false }));
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [popupData.open]);


    const formik = useFormik({
        initialValues: {
            Address: userProfileData.streetAddress || '',
            Area: userProfileData.area || '',
            Pincode: userProfileData.pincode || '',
            Country: userProfileData.countryIDS || '',
            State: userProfileData.stateIDS || '',
            City: userProfileData.cityIDS || '',
            Citizenship: userProfileData.citizenship || '',
            nationality: userProfileData.nationality || '',
            phoneNumber: userProfileData.phoneNumber || '',
            Mobile_Number: userProfileData.mobileNumber || '',
            // Ancestral_Origin: userProfileData.familyOrigin || '',
            Email_id: userProfileData.email || '',
            // user_id: localStorage.getItem('user'),
            // token: localStorage.getItem('token'),
        },
        validationSchema: contactDetailEditSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const response = await editContactDetails(values);
                if (response.status === 200 || response.status === 201) {
                    setPopupData({ open: true, type: 'success', message: response.data.message });
                    setTimeout(() => {
                        navigate(-1);
                    }, 3000);
                } else {
                    setPopupData({ open: true, type: 'error', message: 'Failed to update Contact Details' });
                }
            } catch (error) {
                setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
            } finally {
                setSubmitting(false);
            }
        },
    });

    useEffect(() => {
        const fetchCountry = async () => {
            try {
                const response = await getCountry();
                if (response.status === 200 || response.status === 201) {
                    setCountries(response.data.data);
                }
            } catch (error) {
                setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
            }
        };
        fetchCountry();
    }, []);

    useEffect(() => {
        const fetchState = async () => {
            if (formik.values.Country) {
                try {
                    const response = await getState(formik.values.Country);
                    if (response.status === 200 || response.status === 201) {
                        setStates(response.data.data);
                    }
                } catch (error) {
                    setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
                }
            }
        };
        fetchState();
    }, [formik.values.Country]);

    useEffect(() => {
        const fetchCity = async () => {
            if (formik.values.State) {
                try {
                    const response = await getCity(formik.values.State);
                    if (response.status === 200 || response.status === 201) {
                        setCities(response.data.data);
                    }
                } catch (error) {
                    setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
                }
            }
        };
        fetchCity();
    }, [formik.values.State]);
    return (
        <div className="col-lg-9 col-12">
            <Card className="editProfileBlock">

                <CardHeader
                    avatar={
                        <ArrowBackIcon sx={{ color: '#FF8008', cursor: 'pointer' }} onClick={() => navigate(-1)} />
                    }
                    title='Contact Details'
                    subheader='Update Your Contact Details'
                    titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }} />

                <CardContent>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    label='Address'
                                    variant='outlined'
                                    className='mb-3'
                                    name='Address'
                                    value={formik.values.Address}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Address && Boolean(formik.errors.Address)}
                                    helperText={formik.touched.Address && formik.errors.Address}
                                    InputProps={{
                                        style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                                        inputProps: {
                                            style: { textAlign: 'center' }, // Center-aligns text in the input field
                                        },
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    label='Area'
                                    variant='outlined'
                                    className='mb-3'
                                    name='Area'
                                    value={formik.values.Area}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Area && Boolean(formik.errors.Area)}
                                    helperText={formik.touched.Area && formik.errors.Area}
                                    InputProps={{
                                        style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                                        inputProps: {
                                            style: { textAlign: 'center' }, // Center-aligns text in the input field
                                        },
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    label='Pincode'
                                    variant='outlined'
                                    className='mb-3'
                                    name='Pincode'
                                    value={formik.values.Pincode}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Pincode && Boolean(formik.errors.Pincode)}
                                    helperText={formik.touched.Pincode && formik.errors.Pincode}
                                    InputProps={{
                                        style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                                        inputProps: {
                                            style: { textAlign: 'center' }, // Center-aligns text in the input field
                                        },
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label='Country'
                                    variant='outlined'
                                    className='mb-3'
                                    name='Country'
                                    value={formik.values.Country}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Country && Boolean(formik.errors.Country)}
                                    helperText={formik.touched.Country && formik.errors.Country}
                                >
                                    <MenuItem value=''>Select Country</MenuItem>
                                    {countries.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>{item.country}</MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label='State'
                                    variant='outlined'
                                    className='mb-3'
                                    name='State'
                                    value={formik.values.State}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.State && Boolean(formik.errors.State)}
                                    helperText={formik.touched.State && formik.errors.State}
                                >
                                    <MenuItem value=''>Select State</MenuItem>
                                    {states.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>{item.state}</MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label='City'
                                    variant='outlined'
                                    className='mb-3'
                                    name='City'
                                    value={formik.values.City}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.City && Boolean(formik.errors.City)}
                                    helperText={formik.touched.City && formik.errors.City}
                                >
                                    <MenuItem value=''>Select City</MenuItem>
                                    {cities.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>{item.city}</MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label='Citizenship'
                                    variant='outlined'
                                    className='mb-3'
                                    name='Citizenship'
                                    value={formik.values.Citizenship}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Citizenship && Boolean(formik.errors.Citizenship)}
                                    helperText={formik.touched.Citizenship && formik.errors.Citizenship}
                                >
                                    <MenuItem value=''>Select Citizenship</MenuItem>
                                    {countries.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>{item.country}</MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label='Nationality'
                                    variant='outlined'
                                    className='mb-3'
                                    name='nationality'
                                    value={formik.values.nationality}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.nationality && Boolean(formik.errors.nationality)}
                                    helperText={formik.touched.nationality && formik.errors.nationality}
                                >
                                    <MenuItem value=''>Select Nationality</MenuItem>
                                    {countries.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>{item.country}</MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            {/* <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    label='Ancestral Origin'
                                    variant='outlined'
                                    className='mb-3'
                                    name='Ancestral_Origin'
                                    value={formik.values.Ancestral_Origin}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Ancestral_Origin && Boolean(formik.errors.Ancestral_Origin)}
                                    helperText={formik.touched.Ancestral_Origin && formik.errors.Ancestral_Origin}
                                />
                            </div> */}
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    label='Alternate Number'
                                    variant='outlined'
                                    className='mb-3'
                                    name='phoneNumber'
                                    value={formik.values.phoneNumber}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                                    helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                                    InputProps={{
                                        style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                                        inputProps: {
                                            style: { textAlign: 'center' }, // Center-aligns text in the input field
                                        },
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    disabled
                                    label='Mobile Number'
                                    variant='outlined'
                                    className='mb-3'
                                    name='Mobile_Number'
                                    value={formik.values.Mobile_Number}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Mobile_Number && Boolean(formik.errors.Mobile_Number)}
                                    helperText={formik.touched.Mobile_Number && formik.errors.Mobile_Number}
                                    InputProps={{
                                        style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                                        inputProps: {
                                            style: { textAlign: 'center' }, // Center-aligns text in the input field
                                        },
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    disabled
                                    label='Email Id'
                                    variant='outlined'
                                    className='mb-3'
                                    name='Email_id'
                                    value={formik.values.Email_id}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Email_id && Boolean(formik.errors.Email_id)}
                                    helperText={formik.touched.Email_id && formik.errors.Email_id}
                                    InputProps={{
                                        style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                                        inputProps: {
                                            style: { textAlign: 'center' }, // Center-aligns text in the input field
                                        },
                                    }}
                                />
                            </div>
                        </div>
                        {/* <div className="d-grid col-4 mx-auto mt-2"> */}
                        <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
                            {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
                        </Button>
                        {/* </div> */}
                    </form>
                </CardContent>
            </Card>
            <Popup
                open={popupData.open}
                type={popupData.type}
                message={popupData.message}
                onClose={handleClosePopup}
            />
        </div>
    )
}
